import { jsx as _jsx } from "react/jsx-runtime";
import { FormattedMessage } from "react-intl";
import useModeration from "Hooks/useModeration";
import messages from "./messages";
const MuteButton = ({ pubkey }) => {
    const { mute, unmute, isMuted } = useModeration();
    return isMuted(pubkey) ? (_jsx("button", { className: "secondary", type: "button", onClick: () => unmute(pubkey), children: _jsx(FormattedMessage, { ...messages.Unmute }) })) : (_jsx("button", { type: "button", onClick: () => mute(pubkey), children: _jsx(FormattedMessage, { ...messages.Mute }) }));
};
export default MuteButton;
